import { render, staticRenderFns } from "./MasterProposal.vue?vue&type=template&id=d90170e2&"
import script from "./MasterProposal.vue?vue&type=script&lang=js&"
export * from "./MasterProposal.vue?vue&type=script&lang=js&"
import style0 from "./MasterProposal.vue?vue&type=style&index=0&id=d90170e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports